module.exports = [{"type":"title","text":"2023-11-10"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"永續合約API：支援模擬盤交易下單接口"},{"type":"html","text":"永續合約WebSocket：支援返回觸發價格欄位：sp"},{"type":"html","text":"永續合約WebSocket：訂閱深度支援返回時間欄位"},{"type":"html","text":"永續合約/現貨：24小時價格變動情況支援返回買一賣一價格"},{"type":"html","text":"現貨WebSocket：K線訂閱支援更多內部類型：1分鐘/5分鐘/30分鐘/.../1天...等"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2023-11-10.json
// module id = bGx6
// module chunks = 3